import Select from 'react-select';
import React, { useEffect, useState } from 'react';
import { sortFilterOptions } from 'features/gridReport/functions/sortFilterOptions';
import './FilterSelect.css';

interface FilterSelectProps {
  name: string;
  label: string;
  options: string[];
  value?: string;
  onChange?: (name: string, value: any) => void;
}

// Define the type for our options
type OptionType = {
  value: string;
  label: string;
};

export const FilterSelect: React.FC<FilterSelectProps> = ({
  name,
  label,
  value,
  options,
  onChange,
}) => {
  const [selectedOption, setSelectedOption] = useState<OptionType | null>(null);

  // Handler for when selection changes
  const handleChange = (selected: OptionType | null) => {
    setSelectedOption(selected);
    onChange && onChange(name, selected?.value);
  };

  // Convert string array to the format required by react-select
  const optionsMap: OptionType[] = sortFilterOptions(options).map(item => ({
    value: item,
    label: item,
  }));

  useEffect(() => {
    if (value) {
      setSelectedOption({
        value: value,
        label: value,
      });
    } else {
      setSelectedOption(null);
    }
  }, [value]);

  return (
    <div>
      <label className="slicer-label">{label}</label>
      <Select
        className="slicer-select"
        isSearchable
        isClearable
        options={optionsMap}
        name="label"
        value={selectedOption}
        onChange={handleChange}
        classNamePrefix="slicer"
        placeholder="Select..."
      />
    </div>
  );
};
